import NotificationMixin from './NotificationMixin';
import { formatDateTime, formatDate } from '../utils/dates';

export default {
  mixins: [NotificationMixin],
  methods: {
    formatDateTime,
    formatDate,
    onCreated(item) {
      if (item['name']) {
        this.showMessage(`${item['name']} ${this.$t('global.created')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.created')}`);
      }


      this.$router.push({
        name: `${this.$options.servicePrefix}Show`,
        params: { id: item['@id'] }
      });

    },
    onUploaded(item) {
      this.item.fileUploaded = true;
      this.item.file = item;
      if (item['name']) {
        this.showMessage(`${item['original_name']} ${this.$t('global.uploaded')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.uploaded')}`);
      }
    },
    onSendForm() {
      const createForm = this.$refs.createForm;
      createForm.$v.$touch();
      if (!createForm.$v.$invalid) {
        this.create(createForm.$v.item.$model);
      }
    },
    onUploadForm() {
      const createForm = this.$refs.createForm;
      createForm.$v.$touch();
      if (!createForm.$v.$invalid) {
        this.upload(createForm.$v.item.$model);
      }
    },
    resetForm() {
      this.$refs.createForm.$v.$reset();
      this.item = {};
    }
  },
  watch: {
    created(created) {
      if (!created) {
        return;
      }
      if (this.inputfile) {
        this.uploadFileCreateItem(created['id'],created['@entity'],this.inputfile,'file');
      }
      this.onCreated(created);
    },
    uploaded(uploaded) {
      if (!uploaded) {
        return;
      }

      this.onUploaded(uploaded);
    },

    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        if(this.$route.name != 'RegenPassword') this.$router.push({ name: `Login` });
      } else {
        message && this.showError(message);
      }
    },
  }
};
